import { FunctionComponent, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { initialPaginationData } from "../utils/constants";

import Table, { Column } from "../components/table/Table";
import LayoutContext from "../context/layout-context";

import { AppConfiguration } from "../utils/helpers/types";

import { getInheritedConfig } from "../utils/helpers/data/inheritedModule";
import Button from "../components/button/Button";

interface InheritedModuleProps {
  taskName: string | null;
  taskId: string | null;
}

const InheritedModule: FunctionComponent<InheritedModuleProps> = ({
  taskName,
  taskId,
}) => {
  let timerRef: NodeJS.Timeout;
  const { notify } = useContext(LayoutContext);
  const [pagination, setPagination] = useState({ ...initialPaginationData });
  const [inheritedModule, setInheritedModule] = useState<AppConfiguration[]>(
    []
  );
  const [loading, setLoading] = useState(false);

  const fetchInheritedModule = async (pageNumber = pagination.pageNumber) => {
    setLoading(true);

    try {
      const { data, error, message } = await getInheritedConfig(taskId);

      setLoading(false);

      if (error || !data) {
        const targetString = "Inherited Config with for task ID";

        if (
          message &&
          message !== "No records" &&
          !message.includes(targetString)
        ) {
          notify("error", `Unable to fetch inherited module: ${message}`);
        }
        return;
      }

      setInheritedModule(data.records);

      setPagination({
        ...pagination,
        pageNumber,
        total: data.total,
      });
    } catch (error) {
      notify("error", "Error fetching data");
    }
  };

  useEffect(() => {
    fetchInheritedModule();
  }, [pagination.pageSize]);

  useEffect(() => {
    clearTimeout(timerRef);
    timerRef = setTimeout(() => {
      fetchInheritedModule(1);
    }, 400);
  }, []);

  const columns: Column<AppConfiguration>[] = [
    {
      title: "Key Label",
      dataIndex: "keyLabel",
      key: "keyLabel",
    },
    {
      title: "Key Value",
      dataIndex: "keyValue",
      key: "keyValue",
    },
  ];

  return (
    <main>
      <Table
        dataSource={inheritedModule || []}
        columns={columns}
        pagination={pagination}
        paginateOnBrowser
        onPageChange={(pageNumber) =>
          setPagination({ ...pagination, pageNumber })
        }
        onPageSizeChange={(pageSize) =>
          setPagination({ ...pagination, pageSize, pageNumber: 1 })
        }
        loading={loading}
        className="smaller"
      />
      <br />
      <br />
      <Button>
        <Link to="/task-creation">Back to Task</Link>
      </Button>
    </main>
  );
};

export default InheritedModule;
